import { productAddToCartButtonStyles } from "@insite/content-library/Components/ProductAddToCartButton";
import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { productGridCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductGridCard";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productCardStyles.rightColumnGridContainer = {
    css: css`
        padding: 15px;
    `,
};

productCardStyles.gridContainer = {
    css: css`
        padding: 0;
        border: 1px solid ${getColor("common.border")};
        margin-bottom: 12px;
    `,
};

productCardStyles.actionsGridItem = {
    width: [12, 12, 12, 5, 5],
    css: css`
        padding: 15px 0;
        background: #fafafa;
    `,
};

productAddToCartButtonStyles.typographyProps = {
    css: css`
        font-size: 13px;
        font-weight: normal;
    `,
};

productDescriptionStyles.productDetailLink!.typographyProps!.css = css`
    color: #353432 !important;
    font-size: 14px;
    font-weight: bold;
`;
productGridCardStyles.wrapper!.css = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-bottom: 0px;
`;
paginationStyles.pagination = {
    cssOverrides: {
        pagination: css`
            margin: 0 !important;
            select {
                font-size: 14px !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 0 5px !important;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
        perPageSelect: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 16%;
                            justify-content: flex-start;
                        `,
                        css`
                            width: 30%;
                            justify-content: flex-start;
                        `,
                        css`
                            width: 30%;
                            justify-content: flex-start;
                        `,
                        css`
                            width: auto;
                            justify-content: flex-start;
                        `,
                    ],
                    "min",
                )}
            > div {
                padding: 0;
                width: auto;
                label {
                    width: auto;
                    font-size: 12px;
                    padding-top: 11px;
                    padding-right: 0;
                    text-transform: uppercase;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    width: 42px;
                                    justify-content: flex-start;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "min",
                        )}
                    & + div {
                        width: auto;
                        select {
                            padding-right: 30px !important;
                            border-width: 0 !important;
                        }
                    }
                }
            }
        `,
        linkList: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 84%;
                            justify-content: flex-end;
                        `,
                        css`
                            justify-content: flex-end;
                        `,
                        css`
                            width: 70%;
                            justify-content: flex-end;
                        `,
                        css`
                            width: auto;
                            justify-content: flex-end;
                        `,
                    ],
                    "min",
                )}
            ul li {
                button {
                    width: auto;
                    padding: 0 2px;
                    span {
                        font-size: 12px;
                        color: #353432;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 0px;
                                `,
                            ],
                            "max",
                        )}
                }
            }
        `,
        currentButton: css`
            width: 20px;
            height: 20px;
            padding: 0px;
            color: #59b46c;
            background-color: white;
            border: 0.5px solid #011efb;
            & span {
                color: #011efb !important;
            }
            &:hover {
                background-color: #fff !important;
                color: #59b46c !important;
                border: 0.5px solid #59b46c;
            }
        `,
    },
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
            &:last-of-type {
                border-bottom: none !important;
            }
        `,
    },
};
